import { render } from "./JobForm.vue?vue&type=template&id=1c97e498&scoped=true"
import script from "./JobForm.vue?vue&type=script&lang=js"
export * from "./JobForm.vue?vue&type=script&lang=js"

import "./JobForm.vue?vue&type=style&index=0&id=1c97e498&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c97e498"]])

export default __exports__